import { Route, RouteProps } from "react-router";
import React from "react";
import { useSelector } from "react-redux";
import { IAccountState } from "../../store/models/IAccountState";
import { IState } from "../../store/models/IState";
import { IAccount } from "../../store/models/IAccount";
import Login from "../account/Login";

/**
 * Component used to ensure the user is logged in before allowing to display the component provided on the route.
 * @param param0
 */
export function PrivateRoute({ children, ...rest }: RouteProps): JSX.Element {
    const accountState: IAccountState = useSelector((state: IState) => state.accountState);
    const account: IAccount = accountState?.account;

    return (
        <Route
            {...rest}
            render={() =>
                account?.isAuthenticated ? (
                    children
                ) : <Login />
            }
        />
    );
}